/*
*produceName －推荐的产品名称
*resultTitle －测评结果页中显示的标题
*resultDesc  －测评结果页中显示的描述
*listDesc    －保障清单列表显示的描述
*lowestCost  －保障清单最低费用
*/

export default {
    'Z_XYRS': {
        produceName: '心悦人生两全保险产品计划',
        resultTitle: '全面保障 财富积累',
        resultDesc: '身故保障+重疾保障+意外住院津贴保障+满期保险金',
        listDesc: '身故保险金+满期保险金+重大疾病保险金+意外伤害住院津贴保险金+关爱身故保险金+关爱满期保险金',
        lowestCost: 16.5
    },
    'Z_ZAWL2': {
        produceName: '招商信诺珍爱未来B款教育年金保险'
    },
    'Z_ZZRS': {
        produceName: '自在人生终身年金保险',
        resultTitle: '匠心独运 品质养老',
        resultDesc: '终身可领年金+保证领取20倍基本保险金额+享有全面保障',
        listDesc: '年金+身故保险金',
        lowestCost: 27.4
    },
    'Z_LYAX2': {
        produceName: '招商信诺老友安心三代疾病保险B款',
        // resultTitle: '高龄尊享 防癌保障',
        // resultDesc: '超长保障+免体检',
        // listDesc: '恶性肿瘤保险金+特定恶性肿瘤保险金+身故保险金',
        // lowestCost: 7.7
    },
    'Z_HZZY': {
        produceName: '惠众住院定额给付医疗保险',
        resultTitle: '住院津贴 贴心关怀',
        resultDesc: '疾病住院津贴+意外住院津贴',
        listDesc: '意外伤害住院保险金+保障疾病住院保险金',
        lowestCost: 1.9
    },
    'Z_ENNX': {
        produceName: 'E诺女性特定疾病保险',
        resultTitle: '女性独享 专属呵护',
        resultDesc: '专享产品+女性特定疾病',
        listDesc: '特定疾病保险金',
        lowestCost: 0.2
    },
    'Z_HKYW': {
        produceName: 'E诺航空意外伤害保险',
        resultTitle: '云巅之上 万里无忧',
        resultDesc: '航空意外身故+意外伤残',
        listDesc: '航空意外身故保险金+航空意外伤残保险金',
        lowestCost: 0.2
    },
    'Z_ELYW': {
        produceName: 'E诺陆路公共交通意外伤害保险',
        resultTitle: '陆路公交 全程守护',
        resultDesc: '陆路公共交通意外身故+意外伤残',
        listDesc: '陆路公共交通意外身故保险金+陆路公共交通意外伤残保险金',
        lowestCost: 0.2
    },
    'Z_BWYL': {
        produceName: 'E诺百万住院医疗保险',
        resultTitle: '住院医疗 高额报销',
        resultDesc: '额度高达600万+可续保至80岁',
        listDesc: '一般医疗保险金+重大疾病医疗保险金',
        lowestCost: 0.7,
        OnLine: false
    },
    'Z_ROPPA4': {
        produceName: 'E诺高额公交意外',
        resultTitle: '住院医疗 高额报销',
        resultDesc: '额度高达600万+可续保至80岁',
        listDesc: '一般医疗保险金+重大疾病医疗保险金',
        lowestCost: 0.7,
    },
    'Z_TTWY': {
        produceName: '招商信诺无忧天天五年期意外伤害保险',
    },
    'Z_ROPPA3': {
        produceName: '招商信诺百万守护意外伤害保险产品计划',
    },
    'Z_ZFJS_JY': {
        produceName: '招商信诺筑福金生年金保险',
    },
    'Z_ZFJS': {
        produceName: '招商信诺筑福金生年金保险',
    },
    'Z_BBQH': {
        produceName: '招商信诺宝贝启航2018少儿教育年金保险',
    },
    'Z_AXKJ': {
        produceName: '招商信诺安享康健优享版重大疾病保险',
    },
    'Z_JKZN': {
        produceName: '招商信诺健康之诺医疗保险',
    },
    'Z_IXKJ': {
        produceName: '招商信诺爱享康健重大疾病保险',
    },
}
